/**
 * LoadingSpinner Component
 *
 * Simple CSS-based loading spinner.
 */

import React from "react";
import * as styles from "./LoadingSpinner.module.scss";

const LoadingSpinner = ({ size = "4rem" }) => {
  return (
    <div className={styles.spinner} style={{ width: size, height: size }}>
      <div className={styles.inner}></div>
    </div>
  );
};

export default LoadingSpinner;
